import {
  SHIPMENT_SUMMARY_URL,
  SHIPMENT_SUMMARY_ORDERS_URL
} from "../constants/url.constant";
import { API } from "../api";
import moment from "moment";

export const REQUEST_DAILY_SHIPMENT_SUMMARY_LIST =
  "REQUEST_DAILY_SHIPMENT_SUMMARY_LIST";
export const SET_DAILY_SHIPMENT_SUMMARY_LIST =
  "SET_DAILY_SHIPMENT_SUMMARY_LIST";
export const REQUEST_SHIPMENT_SUMMARY_ORDER_LIST =
  "REQUEST_SHIPMENT_SUMMARY_ORDER_LIST";
export const SET_SHIPMENT_SUMMARY_ORDER_LIST =
  "SET_SHIPMENT_SUMMARY_ORDER_LIST";

const setDailyShipmentSummary = (data) => {
  return {
    type: SET_DAILY_SHIPMENT_SUMMARY_LIST,
    payload: data
  };
};

/**
 * Get daily shipment summary data
 * @param { Object } params to get shipment summary data
 */
export const getDailyShipmentSummary = (params) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_DAILY_SHIPMENT_SUMMARY_LIST });
    try {
      const res = await API.get(SHIPMENT_SUMMARY_URL, { params });
      dispatch(setDailyShipmentSummary(res));
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

const setShipmentSummaryOrders = (data) => {
  return {
    type: SET_SHIPMENT_SUMMARY_ORDER_LIST,
    payload: data
  };
};

/**
 * Get shipment summary orders of specific
 * @param { Object } params to get shipment summary orders
 */
export const getShipmentSummaryOrders = (params) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SHIPMENT_SUMMARY_ORDER_LIST });
    try {
      const res = await API.get(SHIPMENT_SUMMARY_ORDERS_URL, { params });

      if (res.rows && res.rows.length > 0) {
        res.rows = res.rows.map(({ DayAndDate, ...row }) => ({
          DayAndDate: moment(DayAndDate).format("LL"),
          ...row
        }));
      }

      dispatch(setShipmentSummaryOrders(res));
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

const initialState = {
  summary: {
    isLoading: false,
    loaded: false,
    columns: [],
    rows: [],
    totalRows: 0
  },
  orders: {
    isLoading: false,
    loaded: false,
    columns: [],
    rows: [],
    totalRows: 0
  }
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case REQUEST_DAILY_SHIPMENT_SUMMARY_LIST:
      return {
        ...state,
        summary: {
          isLoading: true,
          loaded: false
        }
      };
    case REQUEST_SHIPMENT_SUMMARY_ORDER_LIST:
      return {
        ...state,
        orders: {
          isLoading: true,
          loaded: false
        }
      };
    case SET_SHIPMENT_SUMMARY_ORDER_LIST:
      return {
        ...state,
        orders: {
          isLoading: false,
          loaded: true,
          columns: payload.columns,
          rows: payload.rows,
          totalRows: payload.count
        }
      };
    case SET_DAILY_SHIPMENT_SUMMARY_LIST:
      return {
        ...state,
        summary: {
          isLoading: false,
          loaded: true,
          columns: payload.columns,
          rows: payload.rows,
          totalRows: payload.count
        }
      };
    default:
      return state;
  }
}
